import React, { ReactNode } from 'react';

import { Box } from '@reckon-web/box';
import { Flex } from '@reckon-web/flex';
import { Stack } from '@reckon-web/stack';
import { Text } from '@reckon-web/text';
import { TextLink } from '@reckon-web/text-link';
import { Hidden } from '@reckon-web/media-query';
import { ThemeProvider } from '@reckon-web/theme';

import { BaseTheme, ProductTheme } from './types';

export type ThemeDecoratorProps = ProductTheme &
  BaseTheme & {
    hideFooter?: boolean;
    children: ReactNode;
  };

// FIXME: colors should be strongly typed (enums, not strings)
export const ThemeDecorator: React.FC<ThemeDecoratorProps> = ({
  backgroundColor,
  children,
  footerDescription,
  leftBackgroundImage,
  rightBackgroundImage,
  textColor,
  headerLogo,
  hideFooter = false,
  textLinkColor,
}) => {
  return (
    <Stack width="100vw" height="100vh" flex={1}>
      <Flex flex={1} paddingTop="xlarge" position="relative">
        <ThemeProvider
          theme={{
            colors: {
              background: backgroundColor,
            },
          }}
        >
          <Box
            position="absolute"
            left={0}
            top={0}
            width="100%"
            height="100%"
            background={'base'}
            zIndex={'background'}
          >
            <Hidden below="small">
              <Box position="absolute" bottom={0} left={0}>
                {leftBackgroundImage}
              </Box>
              <Box position="absolute" bottom={0} right={0}>
                {rightBackgroundImage}
              </Box>
            </Hidden>
          </Box>
        </ThemeProvider>

        <Flex
          alignItems="center"
          alignSelf="center"
          direction="column"
          flex={1}
          gap="xlarge"
          height="100%"
          justifyContent="center"
          width="100%"
        >
          {headerLogo}
          <Flex>{children}</Flex>
          <ThemeProvider
            theme={{
              colors: {
                text: textColor,
              },
            }}
          >
            <Text size="small" align="center" color="base">
              By continuing, you agree to our {/* FIXME: textLinkColor */}
              {process.env.serviceTermsLink && (
                <TextLink href={process.env.serviceTermsLink} target="_blank">
                  Terms of Service
                </TextLink>
              )}{' '}
              and {<br />} {/* FIXME: textLinkColor */}
              {process.env.policyLink && (
                <TextLink href={process.env.policyLink} target="_blank">
                  Privacy Policy
                </TextLink>
              )}
            </Text>
            <Flex
              direction="column"
              flex={1}
              justifyContent="flex-end"
              marginBottom="xlarge"
              gap="medium"
            >
              {!hideFooter && (
                <>
                  <Text size="small" align="center" color="base">
                    © {new Date().getFullYear()} The Access Group
                  </Text>
                  <Text size="xsmall" color="muted" align="center">
                    {footerDescription}
                  </Text>
                </>
              )}
            </Flex>
          </ThemeProvider>
        </Flex>
      </Flex>
    </Stack>
  );
};
